<template>
  <div
    ref="sliderContainer"
    class="slider-tabs"
    @mouseup="handleMouseUp"
    @mousedown="handleMouseDown"
    @mouseleave="handleMouseUp"
    @mousemove="handleMouseMove"
  >
    <div class="slider-tabs__wrap" :style="{ transform: `translateX(${currentTranslateX}px)` }">
      <div class="slider-tabs__list">
        <span
          v-for="(item, index) in items"
          :key="getKey(item, index)"
          class="slider-tabs__item"
          :data-index="index"
          :class="{
            'slider-tabs__item--active': isActive(item),
            'slider-tabs__item--no-icon': !getIcon(item),
          }"
          @click="emit('clickItem', item, isMoved)"
        >
          <atomic-icon :id="getIcon(item)" />

          <span>{{ getLabel(item) }}</span>
        </span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  interface SliderTabItem {
    icon?: string;
    label?: string;
    name?: string;
    id?: string | number;
    [key: string]: any;
  }

  const props = withDefaults(
    defineProps<{
      items: SliderTabItem[];
      activeValue?: string;
      iconKey?: string;
      labelKey?: string;
      valueKey?: string;
      itemKey?: string;
    }>(),
    {
      iconKey: 'icon',
      labelKey: 'label',
      valueKey: 'name',
      itemKey: 'id',
    }
  );

  const emit = defineEmits<{
    (e: 'clickItem', item: SliderTabItem, moved: boolean): void;
  }>();

  const sliderContainer = ref(null);

  const { currentTranslateX, handleMouseDown, handleMouseMove, handleMouseUp, isMoved } = useSlider({
    sliderContainer,
  });

  const getIcon = (item: SliderTabItem): string | undefined => item[props.iconKey];

  const getLabel = (item: SliderTabItem): string => item[props.labelKey] ?? '';

  const getKey = (item: SliderTabItem, index: number): string | number => item[props.itemKey] ?? index;

  const isActive = (item: SliderTabItem): boolean => item[props.valueKey] === props.activeValue;

  watch(isMoved, newValue => {
    if (newValue) {
      setTimeout(() => {
        isMoved.value = false;
      }, 0);
    }
  });
</script>

<style src="~/assets/styles/components/slider/tabs.scss" lang="scss" />
